import React, { useState, useCallback, useEffect } from "react";
import { Button } from "./ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import useEmblaCarousel from "embla-carousel-react";

const fantasies = [
  {
    id: 1,
    title: "Eat every drop of your cum",
    video: "https://cdn.lovescape.com/cdn/front/videos/marketing/eatingcum.mp4"
  },
  {
    id: 2,
    title: "Pee & squirt all over you",
    video: "https://cdn.lovescape.com/cdn/front/videos/marketing/peeing.mp4"
  },
  {
    id: 3,
    title: "Ride your cock like a wild dildo",
    video: "https://cdn.lovescape.com/cdn/front/videos/marketing/RideDildo.mp4"
  },
  {
    id: 4,
    title: "Tied up in shibari ropes",
    video: "https://cdn.lovescape.com/cdn/front/videos/marketing/bdsm.mp4"
  },
  {
    id: 5,
    title: "Innocent student you corrupted",
    video: "https://cdn.lovescape.com/cdn/front/videos/marketing/student.mp4"
  },
  {
    id: 6,
    title: "Passed around in a gangbang",
    video: "https://cdn.lovescape.com/cdn/front/videos/marketing/gangb.mp4"
  },
  {
    id: 7,
    title: "Touch her until she cries",
    video: "https://cdn.lovescape.com/cdn/front/videos/marketing/touch.mp4"
  },
  {
    id: 8,
    title: "Deepthroat until she gags",
    video: "https://cdn.lovescape.com/cdn/front/videos/marketing/deepthroat.mp4"
  }
];

const Step3 = ({ selectedGirl }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [emblaRef, emblaApi] = useEmblaCarousel({ 
    loop: true,
    containScroll: 'trimSnaps',
    slidesToScroll: 1
  });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCurrentIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on('select', onSelect);
    return () => {
      emblaApi.off('select', onSelect);
    };
  }, [emblaApi, onSelect]);

  const handleFantasyClick = () => {
    let redirectUrl = "https://lovescape.com/video-generator/imagine?showModal=nonClosablePremium&periodInMonth=12";
    
    // Get userId from sessionStorage
    const userId = sessionStorage.getItem('_userIdParam');
    
    // Append userId parameter if it exists
    if (userId) {
      redirectUrl += `&userId=${encodeURIComponent(userId)}`;
    }
    
    window.location.href = redirectUrl;
  };

  const scrollTo = useCallback((index) => {
    if (emblaApi) emblaApi.scrollTo(index);
  }, [emblaApi]);

  return (
    <div className="step-container step3">
      <div className="step3-content">
        <h2 className="step3-title">
          You made her...
        </h2>

        <div className="new-carousel-wrapper">
          <button
            onClick={scrollPrev}
            className="carousel-arrow carousel-arrow-left"
            aria-label="Previous"
          >
            <ChevronLeft size={32} />
          </button>

          <div className="carousel-embla" ref={emblaRef}>
            <div className="carousel-embla__container">
              {fantasies.map((fantasy, index) => (
                <div className="carousel-embla__slide" key={fantasy.id}>
                  <div 
                    className="video-card"
                    onClick={handleFantasyClick}
                  >
                    <div className="fantasy-placeholder" data-id={fantasy.id}></div>
                    <video
                      autoPlay
                      loop
                      muted
                      playsInline
                      className="video-element"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    >
                      <source src={fantasy.video} type="video/mp4" />
                    </video>
                    <div className="video-text-overlay">
                      <h3 className="video-title">{fantasy.title}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={scrollNext}
            className="carousel-arrow carousel-arrow-right"
            aria-label="Next"
          >
            <ChevronRight size={32} />
          </button>
        </div>

        <div className="carousel-pagination">
          {fantasies.map((_, index) => (
            <button
              key={index}
              onClick={() => scrollTo(index)}
              className={`pagination-dot ${index === currentIndex ? "pagination-dot-active" : ""}`}
              aria-label={`Go to fantasy ${index + 1}`}
            />
          ))}
        </div>

        <Button
          onClick={handleFantasyClick}
          className="btn-unlock"
          size="lg"
        >
          UNLOCK FULL VIDEO NOW →
        </Button>
      </div>
    </div>
  );
};

export default Step3;
